/* eslint-disable */
import { customerService, profileService } from '@/_services'

import { EventBus } from '@/event-bus'

const state = {
  group: {},
  groups: [],
  groupMembers: [],
  count: 0,
  membersCount: 0,
  isLoading: false,
}

const getters = {
  orderedGroups: (state) => state.groups.filter((group) => !group.is_supergroup).reverse(),
}

const actions = {
  fetchGroup({ commit }, { id, params = null }) {
    // commit('reset')

    customerService.getGroup(id, params).then((response) => {
      commit('updateGroup', response.data)
    })
  },
  fetchGroupMembers({ commit }, { id, args }) {
    commit('setIsLoading', true)
    customerService.getGroupMembers(id, args).then((response) => {
      commit('updateGroupMembers', response.data.results)
      commit('updateMembersCount', response.data.count)
      commit('setIsLoading', false)
    })
  },
  addGroupMembers({ commit }, { id, args }) {
    commit('setIsLoading', true)
    return customerService.getGroupMembers(id, args).then((response) => {
      commit('addGroupMembers', response.data.results)
      commit('updateMembersCount', response.data.count)
      commit('setIsLoading', false)
      return response
    })
  },
  fetchAll({ commit }, args = null) {
    commit('setIsLoading', true)
    customerService.getGroups(args).then((response) => {
      commit('updateGroups', response.data.results)
      commit('updateCount', response.data.count)
      commit('setIsLoading', false)
    })
  },
  addPage({ commit }, args = null) {
    commit('setIsLoading', true);
    return customerService.getGroups(args).then((response) => {
      commit('addItemPage', response.data.results)
      commit('updateCount', response.data.count)
      commit('setIsLoading', false)
      return response
    })
  },
  addCustomersToGroup({ commit }, payload) {
    return customerService.addGroupMembers(payload)
  },
  addGroup({ dispatch, commit }, item) {
    return customerService.createGroup(item).then((r) =>
      // commit('addGroup', r.data)
      // dispatch('fetchAll')
      r.data)
  },
  addSingleGroup({ dispatch, commit }, item) {
    commit('setIsLoading', true)
    return customerService.createGroup(item).then((r) => {
      commit('addSingleGroup', r.data)
      return r
    }).finally(() => {
      commit('setIsLoading', false)
    })
  },
  addStylistGroup({ commit }, item) {
    return customerService.createGroup(item).then((r) => {
      commit('addSingleGroup', r.data)
    })
  },
  // eslint-disable-next-line
  patchGroup({ dispatch }, item) {
    customerService.patchGroup(item).then((response) => {
      dispatch('fetchGroupMembers', { id: response.data.pk })
      dispatch('fetchGroup', {id: response.data.pk})
      dispatch('fetchAll')
    })
  },
  fetchStylistGroups({ commit }, { id, kwargs }) {
    commit('setIsLoading', true)
    return profileService.getStylistGroups(id, kwargs).then((response) => {
      commit('addGroups', response.data.results)
      commit('updateCount', response.data.count)
      return response
    }).catch((e) => {

    }).finally(() => {
      commit('setIsLoading', false)
    })
  },
  deleteGroup({ dispatch }, id) {
    customerService.deleteGroup(id).then(() => {
      dispatch('fetchAll')
    })
  },
  deleteGroupMember({ dispatch }, payload) {
    return customerService.deleteGroupMember(payload)
  },
  customReset({ commit }) {
    commit('customReset', state)
  },
  reset({ commit }) {
    commit('reset', state)
  },
}

const mutations = {
  // A no-op mutation must be added to serve as a trigger for a reset.
  reset(state) {
    state.group = {}
    state.groups = []
    state.groupMembers = []
    state.count = 0
    state.membersCount = 0
    state.isLoading = false
  },
  customReset(state) {
    state.groups = []
    state.groupMembers = []
    state.count = 0
    state.membersCount = 0
    state.isLoading = false
  },
  updateGroup(state, group) {
    state.group = group
  },
  updateMembersCount(state, count) {
    state.membersCount = count
  },
  updateGroupMembers(state, members) {
    state.groupMembers = members
  },
  updateGroups(state, items) {
    // this.$helpers.d(items)
    state.groups = items
  },
  addItemPage(state, items) {
    state.groups.push(...items)
  },
  updateCount(state, count) {
    state.count = count
  },
  /** Add group members. Avoid duplicates */
  addGroupMembers(state, members) {
    const existingPks = state.groupMembers.map(m => m.pk)
    state.groupMembers.push(...members.filter(m => !existingPks.includes(m.pk)))
  },
  addGroups(state, item) {
    state.groups.push(...item)
  },
  addSingleGroup(state, item) {
    state.groups.push(item)
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
}

export const groups = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
